import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { SortErgebnisEnum } from '@comparit/shared';
import { SortInfoModalComponent } from './sort-info-modal/sort-info-modal.component';

export type OpenSectionType = 'sort' | null;

/** The row above the list: sort toggle, "n / m Ergebnisse", and on small screens the filter trigger. */
@Component({
  selector: 'ui-results-sort',
  imports: [MatIconModule, MatRadioGroup, MatRadioButton],
  templateUrl: './results-sort.component.html',
  styleUrl: './results-sort.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsSortComponent {
  private readonly dialog = inject(MatDialog);

  readonly hasRatings = input<boolean>(false);
  readonly expectedErgebnisse = input.required<number | null>();
  readonly currentErgebnisse = input.required<number>();
  readonly selected = input.required<SortErgebnisEnum | null>();

  readonly sortChanged = output<SortErgebnisEnum>();
  readonly toggleDescending = output<void>();
  readonly filterRequested = output<void>();

  protected readonly openSection = signal<OpenSectionType>(null);
  protected readonly sortOptions = computed<SortErgebnisEnum[]>(() =>
    this.hasRatings()
      ? [SortErgebnisEnum.Bewertung, SortErgebnisEnum.Versicherer, SortErgebnisEnum.Beitrag]
      : [SortErgebnisEnum.Versicherer, SortErgebnisEnum.Beitrag]
  );

  protected updateOpenSection() {
    this.openSection.update(value => (value !== 'sort' ? 'sort' : null));
  }

  protected openSortInfoDialog(): void {
    this.dialog.open(SortInfoModalComponent);
  }
}
